var indentation_default = {
  "indentZero": "LxbHE",
  "indentOne": "WkaiA",
  "indentTwo": "nciCH",
  "indentThree": "TzCnP",
  "indentFour": "y-F5Y",
  "indentFive": "GTQc7",
  "indentSix": "UJsi4"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
